import React from 'react'

const Shirts = () => {
  return (
    <div>Shirts</div>
  )
}

export default Shirts